import { ReactElement } from 'react'

import { useTranslation } from 'react-i18next'

import { updatePortfolio } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { userHasManageLabelsPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions, useResourceOfPage } from 'hooks'
import { PortfolioGroupBy, Label } from 'types'

import { DeleteField } from '../SharedFields/DeleteField'

interface Props<RecordType> {
    readOnly: boolean
    record: RecordType
    reloadData: () => void
}

function RemoveFromLabelField<RecordType extends PortfolioGroupBy>({
    readOnly = false,
    record,
    reloadData,
}: Props<RecordType>): ReactElement {
    const { t } = useTranslation(['table', 'common'])
    const hasLabelPermissions = useUserHasPermissions(
        userHasManageLabelsPermissions
    )

    const label: Label | null = useResourceOfPage('labelPage')

    const getIsDisabled = (): boolean => {
        return !hasLabelPermissions || readOnly
    }

    return (
        <DeleteField
            disabled={getIsDisabled()}
            okText={t('common:remove', 'Remove')}
            title={t(
                'table:fields.removePortfolioFromLabel.confirmTxt',
                'Are you sure you want to remove this portfolio from {{name}}?',
                {
                    name: label?.name,
                }
            )}
            updateRequestCallback={reloadData}
            updateRequestApi={updatePortfolio}
            updateRequestData={record.portfolio.id}
            updateRequestParams={{
                remove_label_ids: [label?.id],
            }}
            updateRequestSuccessMesg={t(
                'table:fields.removePortfolioFromLabel.successMsg',
                'Portfolio successfully removed'
            )}
        />
    )
}

export default RemoveFromLabelField
